export const TEXT_RESIZE_HANDLER_SIZE = 12;
export const TEXT_RESIZE_ALIGNMENT_PROPERTY = '--ws-block-title-alignment';
export const TEXT_RESIZE_MIN_WIDTH_PROPERTY = '--ws-block-title-min-width';
export const TEXT_RESIZE_MAX_WIDTH_PROPERTY = '--ws-block-title-max-width';
export const COLUMN_ALIGNMENT_PROPERTY = '--ws-column-alignment';
